import React from 'react';
import {
  Container,
  Card,
  Menu,
  Table,
  Label,
  Message,
  Button,
  Divider,
  Header,
} from 'semantic-ui-react';

const CodeBlock = ({ code }) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{
      background: '#1e1e1e',
      borderRadius: '6px',
      padding: '16px',
      marginTop: '12px',
      position: 'relative',
    }}>
      <pre style={{
        margin: 0,
        color: '#d4d4d4',
        fontFamily: 'Monaco, Consolas, monospace',
        fontSize: '13px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
        overflow: 'auto',
        maxHeight: '400px',
      }}>
        <code>{code}</code>
      </pre>
      <Button
        size="small"
        compact
        onClick={handleCopy}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: '#333',
          color: copied ? '#4CAF50' : '#fff',
        }}
      >
        {copied ? '已复制' : '复制'}
      </Button>
    </div>
  );
};

const ModelLabel = ({ children, color = 'blue' }) => (
  <Label size="mini" color={color} style={{ margin: '2px' }}>{children}</Label>
);

class ChannelGuide extends React.Component {
  state = {
    activeTab: 'curl-chat',
  };

  handleTabChange = (_e, { name }) => {
    this.setState({ activeTab: name });
  };

  componentDidMount() {
    // 处理 URL 锚点跳转
    const hash = window.location.hash.replace('#', '');
    if (hash && ['channel-list', 'curl-chat', 'curl-aigc', 'openclaw-chat', 'openclaw-aigc', 'params'].includes(hash)) {
      // 如果是 tab 内容，需要先切换 tab
      if (['curl-chat', 'curl-aigc', 'openclaw-chat', 'openclaw-aigc', 'params'].includes(hash)) {
        this.setState({ activeTab: hash });
      }
      // 延迟滚动到目标位置
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }

  handleAnchorClick = (e, tabName) => {
    e.preventDefault();
    this.setState({ activeTab: tabName });
    setTimeout(() => {
      const element = document.getElementById(tabName);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  render() {
    const baseUrl = window.location.origin;
    const token = 'sk-your-token-here';

    const channels = [
      { 
        id: 11, 
        name: 'newapiOpenai', 
        status: '已启用', 
        models: ['gpt-4', 'gpt-4-turbo', 'gpt-4o', 'gpt-4o-mini', 'gpt-3.5-turbo', 'gpt-3.5-turbo-16k'] 
      },
      { 
        id: 10, 
        name: 'newApiGemini', 
        status: '已启用', 
        models: ['gemini-pro', 'gemini-pro-vision', 'gemini-1.5-pro', 'gemini-1.5-pro-latest', 'gemini-1.5-flash', 'gemini-1.5-flash-latest', 'gemini-1.0-pro', 'gemini-exp'] 
      },
      { 
        id: 9, 
        name: 'newApiAwsClaude', 
        status: '已启用', 
        models: ['claude-3-opus-20240229', 'claude-3-sonnet-20240229', 'claude-3-haiku-20240307', 'claude-3.5-sonnet-20240620', 'claude-3.5-haiku-20240724'] 
      },
      { 
        id: 8, 
        name: 'OpenAI (Vt)', 
        status: '已启用', 
        models: ['gpt-4', 'gpt-4-turbo', 'gpt-4o', 'gpt-4o-mini', 'gpt-3.5-turbo'] 
      },
      { 
        id: 7, 
        name: 'Gemini (Vt)', 
        status: '已启用', 
        models: ['gemini-pro', 'gemini-1.5-pro', 'gemini-1.5-flash', 'gemini-pro-vision'] 
      },
      { 
        id: 6, 
        name: 'Claude (Vt)', 
        status: '已启用', 
        models: ['claude-3-opus-20240229', 'claude-3-sonnet-20240229', 'claude-3-haiku-20240307', 'claude-3.5-sonnet-20240620'] 
      },
      { 
        id: 4, 
        name: '君云AIGC', 
        status: '已启用', 
        models: [
          'GG-2.5 图片生成',
          'Jimeng-2.1 即梦视频',
          'Jimeng-3.0 即梦视频',
          'OS 视频',
          'Kling-1.6 可灵视频',
          'Kling-2.0 可灵视频',
          'Kling-2.1 可灵视频',
          'Kling-2.5 可灵视频',
          'Kling-2.6 可灵视频',
          'Vidu-q2 迹兔视频',
          'Vidu-q3 迹兔视频',
          'Hailuo-02 海螺视频',
          'Hailuo-2.3 海螺视频'
        ] 
      },
    ];

    const channelColumns = [
      { key: 'id', title: 'ID', dataIndex: 'id', width: 60 },
      { key: 'name', title: '渠道名称', dataIndex: 'name', width: 140 },
      {
        key: 'status',
        title: '状态',
        dataIndex: 'status',
        width: 80,
        render: (text) => (
          <Label color={text === '已启用' ? 'green' : 'grey'} size="mini">{text}</Label>
        ),
      },
      {
        key: 'models',
        title: '支持模型',
        dataIndex: 'models',
        render: (models) => (
          <div style={{ maxWidth: '800px' }}>
            {models.map((m, i) => (
              <Label key={i} size="mini" style={{ margin: '2px' }}>{m}</Label>
            ))}
          </div>
        ),
      },
    ];

    // curl 示例
    const curlExamples = {
      openai: `# OpenAI (gpt-4)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "gpt-4",
    "messages": [
      {"role": "system", "content": "你是一个有帮助的助手"},
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100,
    "temperature": 0.7
  }'`,
      gemini: `# Gemini (gemini-pro)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "gemini-pro",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
      claude: `# Claude (claude-3-sonnet)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "claude-3-sonnet-20240229",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
      vtOpenAi: `# OpenAI (Vt) (gpt-4)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "gpt-4",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
      vtGemini: `# Gemini (Vt) (gemini-pro)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "gemini-pro",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
      vtClaude: `# Claude (Vt) (claude-3-sonnet)
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "claude-3-sonnet-20240229",
    "messages": [
      {"role": "user", "content": "用一句话介绍自己"}
    ],
    "max_tokens": 100
  }'`,
    };

    const curlAigcExamples = {
      image: `# 君云AIGC - 图片生成
curl ${baseUrl}/v1/images/generations \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "GG-2.5",
    "prompt": "一只可爱的橘猫在阳光下打盹",
    "size": "1024x1024",
    "n": 1
  }'`,
      video_kling: `# 君云AIGC - 可灵视频
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "Kling-2.0",
    "messages": [
      {"role": "user", "content": "生成一段海边日落的短视频"}
    ],
    "extra_body": {
      "aspect_ratio": "16:9",
      "duration": "5"
    }
  }'`,
      video_vidu: `# 君云AIGC - 迹兔视频
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "Vidu-q3",
    "messages": [
      {"role": "user", "content": "生成一段宇航员在太空行走的视频"}
    ]
  }'`,
      video_hailuo: `# 君云AIGC - 海螺视频
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "Hailuo-02",
    "messages": [
      {"role": "user", "content": "生成一只小猫玩毛线球的动画"}
    ]
  }'`,
      video_jimeng: `# 君云AIGC - 即梦视频
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "Jimeng-2.1",
    "messages": [
      {"role": "user", "content": "生成一只可爱的卡通猫咪在草地上奔跑的视频"}
    ]
  }'`,
      video_os: `# 君云AIGC - OS 视频
curl ${baseUrl}/v1/chat/completions \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "OS",
    "messages": [
      {"role": "user", "content": "生成一段未来科技风格的都市夜景视频"}
    ]
  }'`,
    };

    // 龙虾配置示例
    const openclawExamples = {
      openai: {
        name: 'OpenAI (newapiOpenai)',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "gpt-4",
  "models": {
    "gpt-4": {
      "display_name": "GPT-4",
      "supports vision": true,
      "supports function calling": true
    },
    "gpt-4-turbo": {
      "display_name": "GPT-4 Turbo",
      "supports vision": true
    },
    "gpt-3.5-turbo": {
      "display_name": "GPT-3.5 Turbo"
    }
  }
}`,
        usage: '模型选择: gpt-4 / gpt-4-turbo / gpt-3.5-turbo',
      },
      gemini: {
        name: 'Gemini (newApiGemini)',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "gemini-pro",
  "models": {
    "gemini-pro": { "display_name": "Gemini Pro" },
    "gemini-1.5-pro": { "display_name": "Gemini 1.5 Pro" },
    "gemini-1.5-flash": { "display_name": "Gemini 1.5 Flash" },
    "gemini-pro-vision": {
      "display_name": "Gemini Pro Vision",
      "supports vision": true
    }
  }
}`,
        usage: '模型选择: gemini-pro / gemini-1.5-pro / gemini-1.5-flash / gemini-pro-vision',
      },
      claude: {
        name: 'Claude (newApiAwsClaude)',
        config: `{
  "api_type": "anthropic",
  "base_url": "${baseUrl}",
  "api_key": "${token}",
  "default_model": "claude-3-sonnet-20240229",
  "models": {
    "claude-3-opus-20240229": {
      "display_name": "Claude 3 Opus",
      "max_tokens": 4096
    },
    "claude-3-sonnet-20240229": {
      "display_name": "Claude 3 Sonnet",
      "max_tokens": 4096
    },
    "claude-3-haiku-20240229": {
      "display_name": "Claude 3 Haiku",
      "max_tokens": 4096
    },
    "claude-3.5-sonnet-20240620": {
      "display_name": "Claude 3.5 Sonnet",
      "max_tokens": 8192
    }
  }
}`,
        usage: '模型选择: claude-3-opus / claude-3-sonnet / claude-3-haiku / claude-3.5-sonnet',
      },
      vtOpenAi: {
        name: 'OpenAI (Vt) (vtOpenAi)',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "gpt-4",
  "models": {
    "gpt-4": {
      "display_name": "GPT-4",
      "supports vision": true,
      "supports function calling": true
    },
    "gpt-4-turbo": {
      "display_name": "GPT-4 Turbo",
      "supports vision": true
    },
    "gpt-4o": {
      "display_name": "GPT-4o"
    },
    "gpt-4o-mini": {
      "display_name": "GPT-4o Mini"
    },
    "gpt-3.5-turbo": {
      "display_name": "GPT-3.5 Turbo"
    }
  }
}`,
        usage: '模型选择: gpt-4 / gpt-4-turbo / gpt-4o / gpt-4o-mini / gpt-3.5-turbo',
      },
      vtGemini: {
        name: 'Gemini (Vt) (vtGemini)',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "gemini-pro",
  "models": {
    "gemini-pro": { "display_name": "Gemini Pro" },
    "gemini-1.5-pro": { "display_name": "Gemini 1.5 Pro" },
    "gemini-1.5-flash": { "display_name": "Gemini 1.5 Flash" },
    "gemini-pro-vision": {
      "display_name": "Gemini Pro Vision",
      "supports vision": true
    }
  }
}`,
        usage: '模型选择: gemini-pro / gemini-1.5-pro / gemini-1.5-flash / gemini-pro-vision',
      },
      vtClaude: {
        name: 'Claude (Vt) (vtClaude)',
        config: `{
  "api_type": "anthropic",
  "base_url": "${baseUrl}",
  "api_key": "${token}",
  "default_model": "claude-3-sonnet-20240229",
  "models": {
    "claude-3-opus-20240229": {
      "display_name": "Claude 3 Opus",
      "max_tokens": 4096
    },
    "claude-3-sonnet-20240229": {
      "display_name": "Claude 3 Sonnet",
      "max_tokens": 4096
    },
    "claude-3-haiku-20240307": {
      "display_name": "Claude 3 Haiku",
      "max_tokens": 4096
    },
    "claude-3.5-sonnet-20240620": {
      "display_name": "Claude 3.5 Sonnet",
      "max_tokens": 8192
    }
  }
}`,
        usage: '模型选择: claude-3-opus / claude-3-sonnet / claude-3-haiku / claude-3.5-sonnet',
      },
    };

    const openclawAigcExamples = {
      image: {
        name: '君云AIGC - 图片生成',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "GG-2.5",
  "models": {
    "GG-2.5": {
      "display_name": "图片生成-GG-2.5",
      "task_type": "image_generation",
      "supports_size": ["1024x1024", "1024x1792", "1792x1024"]
    }
  }
}`,
        usage: '图片模型: GG-2.5',
      },
      video: {
        name: '君云AIGC - 视频生成',
        config: `{
  "api_type": "openai",
  "base_url": "${baseUrl}/v1",
  "api_key": "${token}",
  "default_model": "Kling-2.0",
  "models": {
    "Jimeng-2.1": { "display_name": "即梦视频 2.1", "task_type": "video_generation" },
    "Jimeng-3.0": { "display_name": "即梦视频 3.0", "task_type": "video_generation" },
    "OS": { "display_name": "OS 视频", "task_type": "video_generation" },
    "Kling-1.6": { "display_name": "可灵视频 1.6", "task_type": "video_generation" },
    "Kling-2.0": { "display_name": "可灵视频 2.0", "task_type": "video_generation" },
    "Kling-2.1": { "display_name": "可灵视频 2.1", "task_type": "video_generation" },
    "Kling-2.5": { "display_name": "可灵视频 2.5", "task_type": "video_generation" },
    "Kling-2.6": { "display_name": "可灵视频 2.6", "task_type": "video_generation" },
    "Vidu-q2": { "display_name": "迹兔视频 Q2", "task_type": "video_generation" },
    "Vidu-q3": { "display_name": "迹兔视频 Q3", "task_type": "video_generation" },
    "Hailuo-02": { "display_name": "海螺视频 02", "task_type": "video_generation" },
    "Hailuo-2.3": { "display_name": "海螺视频 2.3", "task_type": "video_generation" }
  }
}`,
        usage: '视频模型: Jimeng-2.1/3.0 | OS | Kling-1.6/2.0/2.1/2.5/2.6 | Vidu-q2/q3 | Hailuo-02/2.3',
      },
    };

    const { activeTab } = this.state;

    return (
      <Container style={{ padding: '20px', maxWidth: '1400px' }}>
        <Header as='h2'>AI聚合平台 渠道使用指南</Header>
        <p style={{ color: '#666', marginBottom: '20px' }}>
          包含 7 个渠道的 curl 和龙虾 (OpenClaw) 调用方式
        </p>

        <Message info>
          <Message.Header>快速导航</Message.Header>
          <p>
            跳转到：
            <a href="#channel-list" onClick={(e) => { e.preventDefault(); document.getElementById('channel-list').scrollIntoView({ behavior: 'smooth' }); }}>渠道列表</a>
            {' | '}
            <a href="#curl-chat" onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'curl-chat' }); setTimeout(() => document.getElementById('curl-chat').scrollIntoView({ behavior: 'smooth' }), 100); }}>curl 对话</a>
            {' | '}
            <a href="#curl-aigc" onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'curl-aigc' }); setTimeout(() => document.getElementById('curl-aigc').scrollIntoView({ behavior: 'smooth' }), 100); }}>curl AIGC</a>
            {' | '}
            <a href="#openclaw-chat" onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'openclaw-chat' }); setTimeout(() => document.getElementById('openclaw-chat').scrollIntoView({ behavior: 'smooth' }), 100); }}>龙虾配置</a>
            {' | '}
            <a href="#openclaw-aigc" onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'openclaw-aigc' }); setTimeout(() => document.getElementById('openclaw-aigc').scrollIntoView({ behavior: 'smooth' }), 100); }}>龙虾 AIGC</a>
          </p>
        </Message>

        {/* 渠道列表 */}
        <Card id="channel-list" fluid style={{ marginBottom: '20px' }}>
          <Card.Content>
            <Card.Header>渠道列表</Card.Header>
            <Card.Description>
              <Table celled compact>
                <Table.Header>
                  <Table.Row>
                    {channelColumns.map(col => (
                      <Table.HeaderCell key={col.key} width={col.width}>{col.title}</Table.HeaderCell>
                    ))}
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {channels.map(channel => (
                    <Table.Row key={channel.id}>
                      <Table.Cell>{channel.id}</Table.Cell>
                      <Table.Cell>{channel.name}</Table.Cell>
                      <Table.Cell>
                        <Label color={channel.status === '已启用' ? 'green' : 'grey'} size="mini">
                          {channel.status}
                        </Label>
                      </Table.Cell>
                      <Table.Cell>
                        <div style={{ maxWidth: '800px', display: 'flex', flexWrap: 'wrap' }}>
                          {channel.models.map((m, i) => (
                            <Label key={i} size="mini" style={{ margin: '2px' }}>{m}</Label>
                          ))}
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Card.Description>
          </Card.Content>
        </Card>

        {/* 基础配置 */}
        <Card fluid style={{ marginBottom: '20px' }}>
          <Card.Content>
            <Card.Header>基础配置</Card.Header>
            <Card.Description>
              <p><strong>API 地址：</strong></p>
              <CodeBlock code={baseUrl} />
              <Divider />
              <p><strong>Token 获取方式：</strong></p>
              <ol style={{ color: '#666' }}>
                <li>登录 AI聚合平台 管理后台</li>
                <li>点击左侧菜单 <strong>令牌</strong> → 点击任意令牌名称进入详情</li>
                <li>复制 <strong>密钥</strong>（格式：sk-xxxxxxxx）</li>
              </ol>
              <Message warning size="small">
                <Message.Header>提示</Message.Header>
                <p>如果没有令牌，请联系管理员创建</p>
              </Message>
            </Card.Description>
          </Card.Content>
        </Card>

        {/* Tab 菜单 */}
        <Menu tabular attached="top" style={{ marginBottom: '20px' }}>
          <Menu.Item
            name="curl-chat"
            active={activeTab === 'curl-chat'}
            onClick={this.handleTabChange}
          >
            curl 对话调用
          </Menu.Item>
          <Menu.Item
            name="curl-aigc"
            active={activeTab === 'curl-aigc'}
            onClick={this.handleTabChange}
          >
            curl AIGC 调用
          </Menu.Item>
          <Menu.Item
            name="openclaw-chat"
            active={activeTab === 'openclaw-chat'}
            onClick={this.handleTabChange}
          >
            龙虾对话配置
          </Menu.Item>
          <Menu.Item
            name="openclaw-aigc"
            active={activeTab === 'openclaw-aigc'}
            onClick={this.handleTabChange}
          >
            龙虾 AIGC 配置
          </Menu.Item>
          <Menu.Item
            name="params"
            active={activeTab === 'params'}
            onClick={this.handleTabChange}
          >
            参数说明
          </Menu.Item>
        </Menu>

        {/* curl 对话调用 */}
        {activeTab === 'curl-chat' && (
          <div id="curl-chat">
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>1. OpenAI (newapiOpenai)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="blue">gpt-4</ModelLabel>
                    <ModelLabel color="blue">gpt-4-turbo</ModelLabel>
                    <ModelLabel color="blue">gpt-3.5-turbo</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.openai} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>2. Gemini (newApiGemini)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="green">gemini-pro</ModelLabel>
                    <ModelLabel color="green">gemini-1.5-pro</ModelLabel>
                    <ModelLabel color="green">gemini-1.5-flash</ModelLabel>
                    <ModelLabel color="green">gemini-pro-vision</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.gemini} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>3. Claude (newApiAwsClaude)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="orange">claude-3-opus</ModelLabel>
                    <ModelLabel color="orange">claude-3-sonnet</ModelLabel>
                    <ModelLabel color="orange">claude-3-haiku</ModelLabel>
                    <ModelLabel color="red">claude-3.5-sonnet</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.claude} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>4. OpenAI (Vt) (vtOpenAi)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="blue">gpt-4</ModelLabel>
                    <ModelLabel color="blue">gpt-4-turbo</ModelLabel>
                    <ModelLabel color="blue">gpt-4o</ModelLabel>
                    <ModelLabel color="blue">gpt-4o-mini</ModelLabel>
                    <ModelLabel color="blue">gpt-3.5-turbo</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.vtOpenAi} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>5. Gemini (Vt) (vtGemini)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="green">gemini-pro</ModelLabel>
                    <ModelLabel color="green">gemini-1.5-pro</ModelLabel>
                    <ModelLabel color="green">gemini-1.5-flash</ModelLabel>
                    <ModelLabel color="green">gemini-pro-vision</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.vtGemini} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>6. Claude (Vt) (vtClaude)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="orange">claude-3-opus</ModelLabel>
                    <ModelLabel color="orange">claude-3-sonnet</ModelLabel>
                    <ModelLabel color="orange">claude-3-haiku</ModelLabel>
                    <ModelLabel color="red">claude-3.5-sonnet</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlExamples.vtClaude} />
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* curl AIGC 调用 */}
        {activeTab === 'curl-aigc' && (
          <div id="curl-aigc">
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云AIGC - 图片生成</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="purple">GG-2.5</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.image} />
                  <Message info size="small">
                    <Message.Header>可用尺寸</Message.Header>
                    <p>1024x1024 / 1024x1792 / 1792x1024</p>
                  </Message>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云AIGC - 可灵视频 (Kling)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="pink">Kling-2.0</ModelLabel>
                    <ModelLabel color="pink">Kling-2.1</ModelLabel>
                    <ModelLabel color="pink">Kling-2.5</ModelLabel>
                    <ModelLabel color="pink">Kling-2.6</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_kling} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云AIGC - 迹兔视频 (Vidu)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="violet">Vidu-q2</ModelLabel>
                    <ModelLabel color="violet">Vidu-q3</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_vidu} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云AIGC - 海螺视频 (Hailuo)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="yellow">Hailuo-02</ModelLabel>
                    <ModelLabel color="yellow">Hailuo-2.3</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_hailuo} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云AIGC - 即梦视频 (Jimeng)</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="pink">Jimeng-2.1</ModelLabel>
                    <ModelLabel color="pink">Jimeng-3.0</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_jimeng} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云AIGC - OS 视频</Card.Header>
                <Card.Description>
                  <Label.Group>
                    <ModelLabel color="brown">OS</ModelLabel>
                  </Label.Group>
                  <CodeBlock code={curlAigcExamples.video_os} />
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 龙虾对话配置 */}
        {activeTab === 'openclaw-chat' && (
          <div id="openclaw-chat">
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>1. OpenAI 配置 (newapiOpenai)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.openai.usage}</Message>
                  <CodeBlock code={openclawExamples.openai.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>2. Gemini 配置 (newApiGemini)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.gemini.usage}</Message>
                  <CodeBlock code={openclawExamples.gemini.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>3. Claude 配置 (newApiAwsClaude)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.claude.usage}</Message>
                  <CodeBlock code={openclawExamples.claude.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>4. OpenAI (Vt) 配置 (vtOpenAi)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.vtOpenAi.usage}</Message>
                  <CodeBlock code={openclawExamples.vtOpenAi.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>5. Gemini (Vt) 配置 (vtGemini)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.vtGemini.usage}</Message>
                  <CodeBlock code={openclawExamples.vtGemini.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>6. Claude (Vt) 配置 (vtClaude)</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawExamples.vtClaude.usage}</Message>
                  <CodeBlock code={openclawExamples.vtClaude.config} />
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 龙虾 AIGC 配置 */}
        {activeTab === 'openclaw-aigc' && (
          <div id="openclaw-aigc">
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云AIGC - 图片生成配置</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawAigcExamples.image.usage}</Message>
                  <CodeBlock code={openclawAigcExamples.image.config} />
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>君云AIGC - 视频生成配置</Card.Header>
                <Card.Description>
                  <Message info size="small">{openclawAigcExamples.video.usage}</Message>
                  <CodeBlock code={openclawAigcExamples.video.config} />
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 参数说明 */}
        {activeTab === 'params' && (
          <div>
            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>图片生成参数</Card.Header>
                <Card.Description>
                  <Table celled compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>参数</Table.HeaderCell>
                        <Table.HeaderCell>类型</Table.HeaderCell>
                        <Table.HeaderCell>必填</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>model</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>模型名称：GG-2.5</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>prompt</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>图片描述/提示词</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>size</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>尺寸：1024x1024 / 1024x1792 / 1792x1024</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>n</Table.Cell>
                        <Table.Cell>integer</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>生成数量，默认 1，最大 4</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid style={{ marginBottom: '16px' }}>
              <Card.Content>
                <Card.Header>视频生成参数</Card.Header>
                <Card.Description>
                  <Table celled compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>参数</Table.HeaderCell>
                        <Table.HeaderCell>类型</Table.HeaderCell>
                        <Table.HeaderCell>必填</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>model</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>视频模型：Kling-2.0 / Vidu-q3 / Hailuo-02 等</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>messages</Table.Cell>
                        <Table.Cell>array</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>消息列表，content 为视频描述</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>aspect_ratio</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>比例：16:9 / 9:16 / 1:1</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>duration</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>时长：5 / 10（秒）</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Description>
              </Card.Content>
            </Card>

            <Card fluid>
              <Card.Content>
                <Card.Header>对话模型通用参数</Card.Header>
                <Card.Description>
                  <Table celled compact size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>参数</Table.HeaderCell>
                        <Table.HeaderCell>类型</Table.HeaderCell>
                        <Table.HeaderCell>必填</Table.HeaderCell>
                        <Table.HeaderCell>说明</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>model</Table.Cell>
                        <Table.Cell>string</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>模型名称</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>messages</Table.Cell>
                        <Table.Cell>array</Table.Cell>
                        <Table.Cell>是</Table.Cell>
                        <Table.Cell>消息列表 {"[{role, content}]"}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>temperature</Table.Cell>
                        <Table.Cell>float</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>随机性：0-2，默认 1</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>max_tokens</Table.Cell>
                        <Table.Cell>integer</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>最大生成 token 数</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>top_p</Table.Cell>
                        <Table.Cell>float</Table.Cell>
                        <Table.Cell>否</Table.Cell>
                        <Table.Cell>核采样：0-1</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        )}

        {/* 注意事项 */}
        <Card fluid style={{ marginTop: '20px' }}>
          <Card.Content>
            <Card.Header>注意事项</Card.Header>
            <Card.Description>
              <ul style={{ color: '#666' }}>
                <li>君云AIGC 渠道需要配置 <code>SecretId</code> 和 <code>SecretKey</code>，在 AI聚合平台 后台渠道设置中填写</li>
                <li>视频生成是异步任务，接口会立即返回 <code>task_id</code>，请轮询查询结果</li>
                <li>所有请求都需要携带有效的 <code>Authorization</code> Token</li>
                <li>视频生成可能需要较长时间（1-5分钟），请耐心等待</li>
              </ul>
            </Card.Description>
          </Card.Content>
        </Card>
      </Container>
    );
  }
}

export default ChannelGuide;
